/**
 * New Expedient
 * Expedient for Student Account
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import PlayPauseFormativeAction from './PlayPauseFormativeAction';

/**
 * The PlayPauseAcademicProgram model module.
 * @module model/PlayPauseAcademicProgram
 * @version 1.0
 */
class PlayPauseAcademicProgram {
    /**
     * Constructs a new <code>PlayPauseAcademicProgram</code>.
     * @alias module:model/PlayPauseAcademicProgram
     */
    constructor() { 
        
        PlayPauseAcademicProgram.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PlayPauseAcademicProgram</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PlayPauseAcademicProgram} obj Optional instance to populate.
     * @return {module:model/PlayPauseAcademicProgram} The populated <code>PlayPauseAcademicProgram</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PlayPauseAcademicProgram();

            if (data.hasOwnProperty('academic_program_id')) {
                obj['academic_program_id'] = ApiClient.convertToType(data['academic_program_id'], 'Number');
            }
            if (data.hasOwnProperty('academic_program_title')) {
                obj['academic_program_title'] = ApiClient.convertToType(data['academic_program_title'], 'String');
            }
            if (data.hasOwnProperty('pending_formative_actions')) {
                obj['pending_formative_actions'] = ApiClient.convertToType(data['pending_formative_actions'], [PlayPauseFormativeAction]);
            }
            if (data.hasOwnProperty('postponed_formative_actions')) {
                obj['postponed_formative_actions'] = ApiClient.convertToType(data['postponed_formative_actions'], [PlayPauseFormativeAction]);
            }
        }
        return obj;
    }


}

/**
 * @member {Number} academic_program_id
 */
PlayPauseAcademicProgram.prototype['academic_program_id'] = undefined;

/**
 * @member {String} academic_program_title
 */
PlayPauseAcademicProgram.prototype['academic_program_title'] = undefined;

/**
 * @member {Array.<module:model/PlayPauseFormativeAction>} pending_formative_actions
 */
PlayPauseAcademicProgram.prototype['pending_formative_actions'] = undefined;

/**
 * @member {Array.<module:model/PlayPauseFormativeAction>} postponed_formative_actions
 */
PlayPauseAcademicProgram.prototype['postponed_formative_actions'] = undefined;






export default PlayPauseAcademicProgram;

